export async function* getResponseStream<TEvent>(response: Response): AsyncIterable<TEvent> {
    const reader = response.body?.getReader();
    if (!reader) {
        throw new Error("No reader available");
    }
    const decoder = new TextDecoder();
    let buffer = "";

    try {
        while (true) {
            const { done, value } = await reader.read();

            if (done) {
                break;
            }

            const chunk = decoder.decode(value, { stream: true });
            buffer += chunk;

            // Split by double newline (event separator)
            const parts = buffer.split("\n\n");

            // Keep the last part in buffer (might be incomplete)
            buffer = parts.pop() || "";

            for (const part of parts) {
                const event = parseSSEEvent<TEvent>(part);
                if (event) {
                    yield event.data;
                }
            }
        }
    } finally {
        reader.releaseLock();
    }
}

function parseSSEEvent<T>(eventText: string): { data: T } | null {
    const lines = eventText.split("\n");
    const dataLines: string[] = [];

    for (const line of lines) {
        if (line.startsWith(":")) {
            // Comment, ignore
            continue;
        }

        const colonIndex = line.indexOf(":");
        if (colonIndex === -1) {
            // Line with no colon, treat as field with empty value
            continue;
        }

        const field = line.substring(0, colonIndex);
        const value = line.substring(colonIndex + 2);

        if (field === "data") {
            dataLines.push(value);
        }
    }

    if (dataLines.length > 0) {
        const rawData = dataLines.join("\n");
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return { data: JSON.parse(rawData) as T };
        } catch {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return { data: rawData as T };
        }
    }

    return null;
}
